import { render } from "./FinancialReportsView.vue?vue&type=template&id=72b0aefc"
import script from "./FinancialReportsView.vue?vue&type=script&lang=js"
export * from "./FinancialReportsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__